import {
  IApiRequest,
  IApiResponse,
  IDepartmentResponse,
} from "@miplatform/types";
import {
  API_VERSION,
  SUBSCRIPTION_SERVICE,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_DEPARTMENTS = `${SUBSCRIPTION_SERVICE}/departments`;

export const departments = {
  getAll: async (
    config: IApiRequest = {}
  ): Promise<IApiResponse<IDepartmentResponse[]>> => {
    const options = await apiOptions({
      url: `${API_DEPARTMENTS}`,
      method: "get",
      ...config,
    });
    return apiRequest(options);
  },
  get: async (id: string): Promise<IApiResponse<IDepartmentResponse>> => {
    const options = await apiOptions({
      url: `${API_DEPARTMENTS}/${id}`,
      method: "get",
    });
    return apiRequest(options);
  },
  create: async ({
    data,
    toastMessageConfig,
  }: IApiRequest<IDepartmentResponse>): Promise<
    IApiResponse<IDepartmentResponse>
  > => {
    const options = await apiOptions({
      url: API_DEPARTMENTS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({
    id,
    data,
    toastMessageConfig,
  }: IApiRequest<IDepartmentResponse>): Promise<
    IApiResponse<IDepartmentResponse>
  > => {
    const options = await apiOptions({
      url: `${API_DEPARTMENTS}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({
    data,
    toastMessageConfig,
  }: IApiRequest<IDepartmentResponse>): Promise<IApiResponse<void>> => {
    const options = await apiOptions({
      url: `${API_DEPARTMENTS}/${data.id}`,
      method: "delete",
      data,
      headers: { [X_API_VERSION]: API_VERSION },
    });

    return apiRequest(options, toastMessageConfig);
  },
};
